import palette from '../theme/palette';
import typography from '../theme/typography';
import { ComponentsOverrides } from '@mui/material/styles';

const styleOverrides: ComponentsOverrides['MuiAlert'] = {
  root: {
    fontSize: '14px',
    fontWeight: typography.fontWeightRegular,
    '& *, & .MuiLink-root': {
      color: 'inherit',
      borderBottomColor: 'inherit',
    },
  },
  filledSuccess: {
    color: palette.text.primary,
  },
  filledWarning: {
    color: palette.text.primary,
  },
  filledError: {
    color: palette.common.white,
  },
  filledInfo: {
    color: palette.common.white,
    backgroundColor: palette.secondary.main,
  },
};

export default styleOverrides;
